module.exports = __webpack_public_path__ + "img/portrait-053.de6ead34.jpg";